<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  event: {
    type: Object,
    required: true
  },
  selectedBetType: {
    type: String,
    default: 'h2h'
  },
  isBettingDisabled: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['update:selectedBetType'])

// Computed
const hasOdds = computed(() => props.event?.odds && props.event.odds.length > 0)

// Define v-model for selectedOutcome
const selectedOutcome = defineModel('selectedOutcome')

// const updateBetType = (betType) => {
//   emit('update:selectedBetType', betType)
// }

const selectOutcome = (outcome) => {
  selectedOutcome.value = outcome
  
  // Scroll to
  const bettingPanel = document.getElementById('betting-panel')
  bettingPanel.scrollIntoView({ behavior: 'smooth' })
}
</script>

<template>
  <div class="odds-display">
    <!-- Bet Type Selector -->
    <!-- <v-btn-toggle
      :model-value="selectedBetType"
      @update:model-value="updateBetType"
      variant="outlined"
      divided
      class="mb-6"
    >
      <v-btn v-for="odd in event.odds" :key="odd.id" :value="odd.market_key">
        {{ $t(`events.betting.betTypes.${odd.market_key}`) }}
      </v-btn>
    </v-btn-toggle> -->

    <!-- h2h Odds -->
    <div v-for="odd in event.odds" :key="odd.id" class="mb-8">
      <div class="text-center text-primary my-4">
        <span class="odds-market-title">{{ $t(`events.betting.betTypes.${odd.market_key}`) }}</span>
        <div class="odds-market-underline mx-auto mt-2"></div>
      </div>
      <v-row class="equal-height-row">
        <v-col v-for="outcome in odd.outcomes" :key="outcome.id" cols="12" sm="4" class="d-flex">
          <v-card
            :class="{ 'selected-outcome': selectedOutcome?.id === outcome.id }"
              class="outcome-card flex-grow-1"
              @click="selectOutcome({ ...outcome, market_key: selectedBetType })"
              :disabled="isBettingDisabled"
            >
              <v-card-text class="text-center d-flex flex-column justify-center align-center h-100">
                <div class="outcome-label">{{ outcome.name }}</div>
                <v-chip color="success" size="large" class="mt-2">
                  {{ outcome.price }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
  </div>
</template>

<style scoped>
.equal-height-row {
  align-items: stretch;
}

.outcome-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.outcome-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.outcome-card.selected-outcome {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.05);
}

.outcome-label {
  text-transform: uppercase;
  color: #eee;
  margin-bottom: 4px;
}

.team-name {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 8px;
}

.odds-market-title {
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.odds-market-underline {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #1976d2 60%, #42a5f5 100%);
  border-radius: 2px;
}

</style>